/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import showformmodel from "../showformmodel/showformmodel.vue"
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import VisitActivityModal from "../VisitActivityOrder/VisitActivityOrder.vue"
import CreateScheduleCyclePopUp from "../ScheduleCyclePopup/ScheduleCyclePopup.vue";
import createVisitSchedulePopup from "../CreateVisitBasedSchedulePopup/VisitBasedSchedule.vue";

export default {
    name: "SoaTree",
    props: {
        visitData: {
            type: Object,
            required: true
        },
        version: {
            type: String,
            required: false
        },
        optionsshow: {
            type: Boolean,
            default: true
        },
        subjectId: {
            type: String,
            default: ""
        },
        armCode: {
            type: String,
            default: null
        }
    },
    components: {
        customModal,
        showformmodel,
        manageVisitModal,
        VisitActivityModal,
        CreateScheduleCyclePopUp,
        createVisitSchedulePopup
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            token: store.getters.getIdToken,
            head: {},
            studyId: "",
            visitList: [],
            visitTreeList: [],
            activityList: [],
            activityObj: {},
            openedVisitArray: [],
            formList: [],
            setshowActivityFormModal: false,
            showVisitPopup: [false],
            formActivityId: "",
            loading: false,
            selectedArm: "",
            armList: [],
            showVisitPopup: [],
            rollsprivilages: store.getters.getUserPrivilagesList,
            showSiteModal: false,
            visitId: null,
            showActivityModal: false,
            SelectedVisitId: null,
            selectedVersion: this.version || "",
            visitExpanded: [],
            title: "",
            baseurl: process.env.VUE_APP_Service_URL,
            isArmSpecific: false,
            studyDetails: {},
            versiondetailsobj: {},
            defaultdate: "",
            CreateScheduleCyclePopUp: false,
            selectedCycleId: null,
            selectedPatientId: null,
            showCycleSidePopup: {},
            showCreateSchedule: false,
            visitName :"",
            visitList: [],


        };
    },
    computed: {
        hasRepeatCycleSubject() {
            return !!this.getRepeatCycleSubjectId();
        }
    },
    watch: {
        armCode: {
            immediate: true,
            handler(val) {
                this.selectedArm = val || "";
            }
        }
    },
    async mounted() {
        this.head = {
            headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
            },
        };
         if (this.$route.name !== "visitInfo"){
            this.title = this.$t("navigations.soa")
         }
        this.studyId = store.getters.getStudyIs;
        this.defaultdate = localStorage.getItem("dateformat");
          await this.getStudyDetails();
            this.selectedVersion = this.studyDetails.currentVersion;
        await this.getVlists();
       
        // await this.getStudyArms();
        window.addEventListener("studyIdChanged", async () => {
            this.studyId = store.getters.getStudyIs
            await this.getStudyDetails();
            this.selectedVersion = this.studyDetails.currentVersion;
            await this.getVlists();
           this.$emit("study-changed", this.studyId);
        });
        await this.getpatientshedule();
    },

    methods: {
        async getStudyDetails() {
            try {
                const res = await axios.get(
                    `${this.baseurl}/management/study/getbyid?id=${this.studyId}`,
                    this.head
                );
                this.studyDetails = res.data;
                this.versiondetailsobj = res.data;
                const currentVersion = res.data.currentVersion;
                this.version = currentVersion;

                const versionObj = res.data.versions.find(
                    v => v.version === currentVersion
                );

                this.isArmSpecific = versionObj ? versionObj.isArmSpecific : false;
                this.routpage();
            } catch (err) {
                console.log("error in get study", err);
            }
        },
        async getVlists() {
            this.loading = true;
            this.visitList = [];
            try {
                const response = await axios.get(
                    `${this.baseapi}/management/visit/listvisit?StudyId=${this.studyId}&StudyVersion=${this.selectedVersion}&ArmCode=${this.selectedArm}&SortProperty=visitOrder&SubjectId=${this.subjectId}`, this.head
                );
                console.log("Visit Activity Orders Response:", response.data);
                this.visitList = response.data.results;
                this.visitTreeList = this.buildVisitTree(this.visitList);
                this.visitList.forEach(visit => {
                    this.activityList[visit.visitId] = [];
                });
                this.showVisitPopup = this.visitList.map(() => false);
                this.visitExpanded = this.visitList.map(() => false);

                this.loading = false;
            } catch (error) {
                console.error("Error fetching Visit Activity Orders:", error);
            }
        },
        buildVisitTree(visits) {
            const tree = [];
            const cycleMap = {};
            const phaseMap = {};   

            visits.forEach((visit, index) => {
                visit.__visitIndex = index;

                const phase = visit.studyPhase;

                //  PHASE NODE
                if (phase) {

                    if (!phaseMap[phase]) {
                        phaseMap[phase] = {
                            type: "phase",
                            phaseName: phase,
                            displayText: phase,
                            nodes: []
                        };

                        tree.push(phaseMap[phase]);
                    }

                    // -------- EXISTING CYCLE LOGIC INSIDE PHASE --------
                    if (visit.isCycleVisit) {

                        const key = `${phase}_${visit.cycleName}`;

                        if (!cycleMap[key]) {
                            cycleMap[key] = {
                                type: "cycle",
                                cycleName: visit.cycleName,
                                occurence: visit.occurence,
                                cycleId: visit.cycleId,
                                displayText: `${visit.cycleName}`,
                                visits: []
                            };

                            phaseMap[phase].nodes.push(cycleMap[key]);
                        }

                        cycleMap[key].visits.push(visit);

                    } else {

                        phaseMap[phase].nodes.push({
                            type: "visit",
                            visit
                        });

                    }

                } else {

                    if (visit.isCycleVisit) {
                        const key = `${visit.cycleName}`;

                        if (!cycleMap[key]) {
                            cycleMap[key] = {
                                type: "cycle",
                                cycleName: visit.cycleName,
                                occurence: visit.occurence,
                                cycleId: visit.cycleId,
                                displayText: `${visit.cycleName}`,
                                visits: []
                            };

                            tree.push(cycleMap[key]);
                        }

                        cycleMap[key].visits.push(visit);

                    } else {

                        tree.push({
                            type: "visit",
                            visit
                        });

                    }
                }
            });

            Object.values(cycleMap).forEach(cycle => {
                cycle.visits.sort((a, b) => {
                    const dayA = extractDay(a.visitNo);
                    const dayB = extractDay(b.visitNo);

                    if (dayA !== null && dayB !== null) return dayA - dayB;
                    const dateA = getVisitSortDate(a);
                    const dateB = getVisitSortDate(b);
                    if (dateA && dateB) return dateA - dateB;
                    if (dateA) return -1;
                    if (dateB) return 1;

                    return String(a.visitNo || "").localeCompare(String(b.visitNo || ""));
                });
            });

            return tree.sort((a, b) => {
                const dateA = a.type === "visit"
                    ? getVisitSortDate(a.visit)
                    : getCycleSortDate(a);
                const dateB = b.type === "visit"
                    ? getVisitSortDate(b.visit)
                    : getCycleSortDate(b);

                if (dateA && dateB) return dateA - dateB;
                if (dateA) return -1;
                if (dateB) return 1;

                return 0;
            });

            function extractDay(visitNo) {
                const match = visitNo?.match(/D(\d+)/i);
                return match ? parseInt(match[1], 10) : null;
            }

            function getVisitSortDate(visit) {
                if (!visit) return null;
                if (visit.visitStatus === "Completed" || visit.visitStatus === "In Progress") {
                    return visit.actualVisitStartDate ? new Date(visit.actualVisitStartDate) : null;
                }
                return visit.visitDate ? new Date(visit.visitDate) : null;
            }

            function getCycleSortDate(cycle) {
                if (!cycle?.visits?.length) return null;
                const dates = cycle.visits
                    .map(v => getVisitSortDate(v))
                    .filter(Boolean)
                    .sort((a, b) => a - b);
                return dates.length ? dates[0] : null;
            }
        },
        filter(data) {
            if (data) {
                return moment(data)
                    .utc()
                    .format(this.defaultdate);
            }
        },
        setdate(visitobj) {
            let datereturn = "";
            if (visitobj.visitStatus == "Completed" || visitobj.visitStatus == "In Progress") {
                datereturn = this.filter(visitobj.actualVisitStartDate);
            } else {
                datereturn = this.filter(visitobj.visitDate);
            }
            return datereturn;
        },
        getRepeatCycleSubjectId() {
            return (
                this.visitData?.subjectId ||
                this.visitData?.patientId ||
                this.visitData?.patientid ||
                null
            );
        },
        openScheduleCyclePopup(cycleId) {
            const subjectId = this.getRepeatCycleSubjectId();
            if (!subjectId) {
                alert("Subject not found for repeat cycle.");
                return;
            }
            this.selectedPatientId = subjectId;
            this.selectedCycleId = cycleId;
            this.CreateScheduleCyclePopUp = true;
        },
        toggleCycleSidePopup(nodeIndex) {
            this.showCycleSidePopup = {
                ...this.showCycleSidePopup,
                [nodeIndex]: !this.showCycleSidePopup[nodeIndex]
            };
        },
        closeCycleSidePopup(nodeIndex) {
            if (!this.showCycleSidePopup[nodeIndex]) return;
            this.showCycleSidePopup = {
                ...this.showCycleSidePopup,
                [nodeIndex]: false
            };
        },
        async visitPopup(visitIdEdit, id) {
            if (id) {
                document.getElementById(id).style.display = "none"
            }
            this.showSiteModal = true
            this.visitId = visitIdEdit
        },
        async closeModal() {
            this.showSiteModal = false;
            await this.getVlists();
        },
        async getActivities(visitId, vIndex) {
            let openedActivity = {
                "visitId": visitId,
                "index": vIndex
            }
            const existingIndex = this.openedVisitArray.findIndex(
                item => item.visitId === visitId && item.index === vIndex
            );

            if (existingIndex !== -1) {
                this.openedVisitArray.splice(existingIndex, 1);
            } else {
                this.openedVisitArray.push(openedActivity);
            }

            try {
                const response = await axios.get(
                    `${this.baseapi}/management/visit/listvisitactivity?visitId=${visitId}`, this.head
                );
                let data = response.data.entities || [];
                await data.forEach(visitData => {
                    this.formList[visitData.activityId] = [];
                });
                this.activityList[visitId][vIndex] = data;
            } catch (error) {
                console.error("Error fetching Activities for VisitId " + visitId + ":", error);
            }
        },
        async getActivityForms(activityId, aIndex) {
            try {
                const response = await axios.get(
                    `${this.baseapi}/management/study/getsoa?Id=${activityId}`, this.head
                );
                console.log("SOA Response:", response.data);
                this.formList[activityId][aIndex] = response.data.eCRF;
                console.log("Form List:", this.formList);
            } catch (error) {
                console.error("Error fetching SOA:", error);
            }
        },
        async viewForms(tempId) {
            this.formActivityId = tempId;
            this.setshowActivityFormModal = true;
        },
        closeformActivityModal() {
            this.setshowActivityFormModal = false;
        },
        async getStudyArms() {
            try {
                const response = await axios.get(
                    `${this.baseapi}/fhir-service/arm/getarmsbystudyid?study_id=${this.studyId}`, this.head
                );
                console.log("Study Arms Response:", response.data);
                this.armList = response.data;
            }
            catch (error) {
                console.error("Error fetching Study Arms:", error);
            }
        },
        toggleVisitMenu(index) {

            this.showVisitPopup = this.showVisitPopup.map(() => false);

            this.showVisitPopup[index] = true;

        },
        async deleteVisit(id) {
            this.closePopover();
            if (confirm(this.$t('navigations.are you sure you want to delete this visit?'))) {
                try {
                    await axios.delete(
                        `${this.baseapi}/management/visit/delete?id=${id}`,
                        this.head
                    );

                    alert(this.$t("navigations.visit deleted successfully"));
                    this.getVlists();
                } catch (err) {
                    alert(this.$t("navigations.failed due to internal error"));
                    console.error(err);
                }
            }

            this.showVisitPopup = this.showVisitPopup.map(() => false);
        },
        visitPopup(visitId) {
            this.closePopover(`visit-popup-${visitId}`);
            this.showVisitPopup = this.showVisitPopup.map(() => false);
            this.showSiteModal = true;
            this.visitId = visitId;
        },
        async openCreateSchedule(visitId, visitName) {
            this.showCreateSchedule = true;
            this.visitId = visitId;
            this.visitName = visitName;
            this.closePopover(`visit-popup-${visitId}`);
        },
        async closeCreateSchedule() {
            this.getpatientshedule();
            this.showCreateSchedule = false;
            this.$emit('triggerScheduleRefresh');
        },
        openVisitActivityModal(visitId) {
            this.closeAllPopovers();
            this.SelectedVisitId = visitId;
            this.showActivityModal = true;
        },
        async closeModal() {
            this.showSiteModal = false;
            await this.getStudyDetails();
            await this.getVlists();
        },

        toggleVisit(vIndex, visitId) {
            this.visitExpanded[vIndex] = !this.visitExpanded[vIndex];

            if (this.visitExpanded[vIndex]) {
                this.getActivities(visitId, vIndex);
            }
        },
        closePopover(popoverId) {
            const popover = document.getElementById(popoverId);
            if (popover && typeof popover.hidePopover === 'function') {
                popover.hidePopover();
            }
        },

        closeAllPopovers() {
            this.armList.forEach(arm => {
                this.closePopover(`arm-popup-${arm.ArmCode}`);
            });
            this.visitList.forEach(visit => {
                if (visit && visit.visitId) {
                    this.closePopover(`visit-popup-${visit.visitId}`);
                }
            });
        },
        closeActivityModal() {
            this.showActivityModal = false;
            this.getVlists();
        },
        async getpatientshedule(){
            await axios.get(`${this.baseurl}/management/patientschedule/getpatientshedule?patientID=${this.subjectId}&ItemCount=500&sortprop=VisitNo`,this.head)
            .then((response)=>{
                console.log("Patient Schedule",response.data);
                this.getVisitList(response.data.data);
            })
            .catch((error)=>{
                console.error("Error fetching patient schedule",error);
            })
        },
        async getVisitList(patientSchedule) {
            this.visitList = [];

            patientSchedule.forEach(schedule => {
                this.visitList.push({
                    visitNo: schedule.visitNo,
                    visitName: schedule.visitName,
                    isCycleVisit: schedule.isCycleVisit
                });
            });

            console.log("Visit List from Patient Schedule", this.visitList);
        },
        isVisitActivated(visit) {
            return this.visitList.some(v => {
                if (visit.isCycleVisit) {
                    return v.visitName === visit.visitFormName || v.visitName === visit.visitName;
                } else {
                    return v.visitNo === visit.visitNo;
                }
            });
        }
    }
};
